import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import Pagination from '../../components/Pagination';
import StatusBadge from '../../components/StatusBadge';
import { listAuditLog } from '../../utils/queries';

const PAGE_SIZE = 25;

export default function AuditLog() {
	const { activeStoreId } = useContext(MyContext);
	const [entries, setEntries] = useState([]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(0);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		listAuditLog({
			limit: PAGE_SIZE,
			offset: page * PAGE_SIZE,
			storeId: activeStoreId || undefined,
		}).then((result) => {
			if (result?.success) {
				setEntries(result.data.entries);
				setTotal(result.data.pagination.total);
			}
			setLoading(false);
		});
	}, [page, activeStoreId]);

	const columns = [
		{
			key: 'method',
			header: 'Method',
			render: (value) => (
				<StatusBadge status={value === 'DELETE' ? 'failed' : value === 'POST' ? 'active' : 'pending'} text={value} />
			),
		},
		{ key: 'path', header: 'Path' },
		{ key: 'statusCode', header: 'Status' },
		{ key: 'actorEmail', header: 'Actor' },
		{
			key: 'createdAt',
			header: 'When',
			render: (value) => (value ? new Date(value).toLocaleString() : ''),
		},
	];

	return (
		<div className='py-8 pr-8'>
			<h1 className='text-2xl font-light tracking-tight mb-2'>Audit Log</h1>
			<p className='text-sm text-gray-500 mb-6'>
				Every create, update, and delete made through this admin, logged automatically.
			</p>

			<DataTable columns={columns} data={entries} loading={loading} emptyHeading='No audit log entries yet' />
			<Pagination pageCount={Math.ceil(total / PAGE_SIZE)} currentPage={page} onPageChange={setPage} />
		</div>
	);
}
